<div #content [hidden]="!debug">
    <ng-content></ng-content>
</div>
<a [routerLink]="[]" queryParamsHandling="merge" (click)="copy(content)">{{label}}</a>
